import { render, staticRenderFns } from "./lostActiveStatistics.vue?vue&type=template&id=336e8a37&"
import script from "./lostActiveStatistics.vue?vue&type=script&lang=js&"
export * from "./lostActiveStatistics.vue?vue&type=script&lang=js&"
import style0 from "./lostActiveStatistics.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports